"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
const layout_1 = require("./shared/layout");
function UploadMediaComponent({ UploadFile, RaiseInfo, RaiseAlert, ShowIcon }) {
    const onFileChange = (e) => __awaiter(this, void 0, void 0, function* () {
        const files = e.target.files ? [...e.target.files] : [];
        e.target.value = "";
        for (const fileToUpload of files) {
            const result = yield UploadFile(fileToUpload);
            // Show message for success and failure, but not cancellation
            if (result.Outcome === "Succeeded") {
                RaiseInfo(`Successfully uploaded "${fileToUpload.name}"`);
            }
            else if (result.Outcome === "Failed") {
                RaiseAlert(react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("p", null,
                        "Failed to upload ",
                        fileToUpload.name,
                        "."),
                    react_1.default.createElement("p", null, result.Error),
                    react_1.default.createElement("p", null,
                        "If you are still experiencing problems please ",
                        react_1.default.createElement("a", { href: 'https://support.oxfordeconomics.com/', target: "_blank" }, "contact support."))));
            }
        }
    });
    return react_1.default.createElement(layout_1.FlexRow, { style: { alignItems: "center", cursor: "pointer" } },
        ShowIcon && react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { style: { marginRight: "5px" }, icon: free_solid_svg_icons_1.faUpload }),
        react_1.default.createElement("label", { className: "text-decoration-none text-transform-none", style: { margin: "0px 5px 0px 0px", cursor: "pointer" }, htmlFor: "file-upload" }, "Upload"),
        react_1.default.createElement("input", { id: "file-upload", style: { display: "none" }, type: "file", multiple: true, onChange: onFileChange }));
}
UploadMediaComponent.displayName = 'UploadMedia';
exports.default = UploadMediaComponent;
//# sourceMappingURL=upload-media-component.js.map